import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import styled from 'styled-components'
import moment from 'moment'
import axios from 'axios'
import { queryClient } from '../../config'
import getWorkspaceURL from '../../config/workspaceURL'

const NetDocuments = ({ className }) => {
  const [location, setLocation] = useState('US')
  const [repositoryId, setRepositoryId] = useState('')
  const [cabinetId, setCabinetId] = useState('')
  const [lastUpdateCabinet, setLastUpdateCabinet] = useState(false)
  const [lastUpdate, setLastUpdate] = useState(false)
  const [options, setOptions] = useState([])

  const fetchNetDocuments = async () => {
    const { data } = await axios.get('/api/netdocuments')
    if (data.location) {
      setLocation(data.location)
      fetchCabinets()
    }
    if (data.repositoryId) {
      setRepositoryId(data.repositoryId)
    }
    if (data.cabinetId) {
      setCabinetId(data.cabinetId)
    }
    if (data.lastUpdateCabinet) {
      setLastUpdateCabinet(data.lastUpdateCabinet)
    }
    if (data.lastUpdate) {
      setLastUpdate(data.lastUpdate)
    }
  }

  const fetchCabinets = async () => {
    try {
      const { data } = await axios.get('/api/netdocuments/cabinets')
      if (data) {
        setOptions(data)
      }
    } catch (e) {

    }
  }

  useEffect(() => {
    fetchNetDocuments()
  }, [])

  const connection = async () => {
    if (location && repositoryId) {
      const { data } = await axios.post('/api/netdocuments', {
        location,
        repositoryId,
      })
      console.log('data', data)

      const state = {
        tenancy: window.tenancy,
        back_uri: window.location.href,
        authorization: axios.defaults.headers.common['Authorization'],
      }

      window.location.href = `${getWorkspaceURL()}/api/auth/nd?state=${encodeURI(
        JSON.stringify(state))}`
    }
  }

  const importCabinet = async () => {
    try {
      const { data } = await axios.post('/api/netdocuments/cabinets',
        { cabinetId })
      if (data.lastUpdateCabinet) {

        const URL = '/api/types?fields=name,type,_id'
        const { data: types } = await axios.get(URL)
        await queryClient.clear()
        await queryClient.setQueryData(URL, types)
        setLastUpdateCabinet(data.lastUpdateCabinet)
      }
    } catch (e) {

    }
  }

  return (<div className={'container-fluid py-2'}>
      <label
        className={'mb-2 text-uppercase'}>{'NetDocuments configuration'}</label>
      <div className={classNames('w-100 border border-dark p-4', className)}>
        <div className={'row'}>
          <div className={'col-3'}>
            <div className="form-group">
              <label htmlFor="displayName">{'Application Region'}</label>
              <select className="form-control rounded-0" id="applicationRegion"
                      value={location}
                      onChange={event => {
                        setLocation(event.target.value)
                      }}>
                <option value={'US'}>{'United States'}</option>
                <option value={'EU'}>{'United Kingdom'}</option>
                <option value={'AU'}>{'Australia'}</option>
                <option value={'DE'}>{'Germany'}</option>
                <option value={'CAN'}>{'Canada'}</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="displayName">{'Repository ID'}</label>
              <input type="text" className="form-control rounded-0"
                     id="applicationKey" value={repositoryId}
                     onChange={event => setRepositoryId(event.target.value)} />
            </div>
            <div className={'row'}>
              <div className="col-12">
                {lastUpdate ? (
                  <p>Last updated connections on {moment(lastUpdate).format('MM/DD/YYYY')} at {moment(lastUpdate).format('hh:mm A')}</p>) : (
                  <p>NetDocuments has not yet been connected.</p>)}
              </div>
              <div className="col-12">
                <button
                  className="btn btn-secondary dart-btn text-uppercase w-75"
                  onClick={connection}>
                  Connection
                </button>
                <div className="form-group mt-2">
                  <label htmlFor="displayName">{'Cabinets'}</label>
                  <select className="form-control rounded-0"
                          id="cabinet"
                          value={cabinetId}
                          disabled={!lastUpdate || !options.length}
                          onChange={event => {
                            setCabinetId(event.target.value)
                          }}>
                    <option value={''}></option>
                    {options.map(option =>
                      (<option key={option.id}
                               value={option.id}>{option.name}</option>),
                    )}
                  </select>
                </div>
                {lastUpdateCabinet ? (
                  <p>Models last refreshed on {moment(lastUpdateCabinet).format('MM/DD/YYYY')} at {moment(
                    lastUpdateCabinet).format('hh:mm A')}</p>) : (
                  <p>Cabinet have not yet been imported.</p>)}

                <button
                  className="btn btn-secondary dart-btn text-uppercase w-75"
                  disabled={!lastUpdate || !cabinetId}
                  onClick={importCabinet}>
                  Import Cabinet
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default styled(NetDocuments)`
  background-color: ${props => props.theme.colorTable.plain} !important;
  border-color: ${props => props.theme.colorTable.border} !important;
  color: ${props => props.theme.colorTable.textLight} !important;
`
